module.exports = __webpack_public_path__ + "assets/img/confirm.4b3d992c.png";